<template>
    <el-dialog title="职责分工" :visible.sync="dialogVisible" width="600px" @closed="$emit('closed')">
      <el-form :model="deptDuty" :rules="rules" ref="editForm">
        <el-form-item
          label="部门名称"
          prop="deptName"
          :label-width="formLabelWidht"
        >
          <el-input
            v-model="deptDuty.deptName"
            auto-complete="off"
            placeholder="请输入部门名称"
            style="width: 360px"
          ></el-input>
        </el-form-item>
        <el-form-item label="主体单位" :label-width="formLabelWidht">
          <el-radio v-model="deptDuty.root" :label="true">是</el-radio>
          <el-radio v-model="deptDuty.root" :label="false">否</el-radio>
        </el-form-item>
        <el-form-item label="部门简介" :label-width="formLabelWidht">
          <el-input
            type="textarea"
            v-model="deptDuty.profile"
            auto-complete="off"
            placeholder="请输入部门简介"
            style="width: 360px"
          ></el-input>
        </el-form-item>
        <el-form-item label="启用状态" :label-width="formLabelWidht">
          <el-radio v-model="deptDuty.enable" :label="true">启用</el-radio>
          <el-radio v-model="deptDuty.enable" :label="false">停用</el-radio>
        </el-form-item>
        <el-form-item
          label="排序码"
          prop="sortCode"
          :label-width="formLabelWidht"
        >
          <el-input
            type="number"
            v-model="deptDuty.sortCode"
            auto-complete="off"
            placeholder="请输入数字作为排序码"
            style="width: 360px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveDeptDuty">保 存</el-button>
      </div>
    </el-dialog>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      dialogVisible: true,
      formLabelWidht: "120px",
      formInputWidth: "300px",
      // deptDuty: {
      //   root: false,
      //   enable: true
      // },
      rules: {
        deptName: [
          { required: true, message: "请输入单位名称", trigger: "change" },
        ],
        sortCode: [
          { required: true, message: "请输入排序码", trigger: "change" },
        ],
      },
      editorOption: {},

      deptDuty: {
        root: false,
        enable: true,
      },
    };
  },
  methods: {
    saveDeptDuty() {
      // 保存成功
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$emit("refreshHandle");
        }
      });
    },
  },
  mounted() {
    this.deptDuty = Object.assign({}, this.form);
  },
};
</script>

<style>
</style>
